import { memo } from 'react';
import { useTheme } from '@mui/material';
import EmptyFolderIllustrationLight from './emptyFolder.svg?react';
import EmptyFolderIllustrationDark from './emptyFolder_dark.svg?react';

export const EmptyFolderIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <EmptyFolderIllustrationDark aria-hidden="true" {...props} />;
    return <EmptyFolderIllustrationLight aria-hidden="true" {...props} />;
  },
);
